export const diagnosisSymptomsData = {
  data: [
    {
      id: 12,
      name: 'Other chronic pain',
      patientFriendlyName: 'Chronic Pain – Treated with Opioids',
      ICD10: 'G89.29',
      ICD9Code: '338.29',
      procedure: false,
      billable: true,
      diagnosis: true,
      snomed: null,
      active: true,
      createdAt: '2019-09-09T20:48:58.903Z',
      updatedAt: '2019-12-20T15:01:29.440Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 80,
      name: null,
      patientFriendlyName: 'Cold Intolerance',
      ICD10: null,
      ICD9Code: null,
      procedure: false,
      billable: false,
      diagnosis: false,
      snomed: null,
      active: false,
      createdAt: '2019-09-09T20:48:58.903Z',
      updatedAt: '2019-12-20T15:01:29.440Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 81,
      name: null,
      patientFriendlyName: 'Constipation',
      ICD10: null,
      ICD9Code: null,
      procedure: false,
      billable: false,
      diagnosis: false,
      snomed: null,
      active: true,
      createdAt: '2019-09-09T20:48:58.903Z',
      updatedAt: '2019-12-20T15:01:29.440Z',
      createdBy: null,
      updatedBy: null,
    },
  ],
  total: 3,
};
